import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from "react";
import CrehanaForBusiness from "@crehana/icons/logos/CrehanaForBusiness";
import cn from "clsx";
import { jsx as _jsx } from "react/jsx-runtime";
var OrganizationLogoImage = function OrganizationLogoImage(_ref) {
  var src = _ref.src,
    alt = _ref.alt,
    colors = _ref.colors,
    className = _ref.className,
    customSizeLogo = _ref.customSizeLogo;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loaded = _useState2[0],
    setLoaded = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    is404Image = _useState4[0],
    setIs404Image = _useState4[1];
  var style = loaded ? {
    maxHeight: '32px',
    maxWidth: '128px'
  } : {
    width: 128,
    height: 32
  };

  /**
   * This is a workaround to avoid render a broken image
   */
  var handleImageError = function handleImageError() {
    return setIs404Image(true);
  };
  if (is404Image) {
    return /*#__PURE__*/_jsx(CrehanaForBusiness, {
      size: 32,
      "aria-hidden": true,
      color: colors === null || colors === void 0 ? void 0 : colors.primary,
      secondaryColor: colors === null || colors === void 0 ? void 0 : colors.secondary,
      className: className
    });
  }
  return /*#__PURE__*/_jsx("img", {
    src: src,
    alt: alt,
    "aria-hidden": true,
    onLoad: function onLoad() {
      setLoaded(true);
    },
    style: customSizeLogo ? _objectSpread({}, style) : style,
    className: cn(!customSizeLogo && 'h-24', className),
    onError: handleImageError
  });
};
export default OrganizationLogoImage;